// Lightweight localStorage helpers for offline-first session drafts + active session pointer.

const ACTIVE_KEY = "ssc:active-session";
const DRAFT_KEY = "ssc:draft-session";
const SYNC_KEY = "ssc:sync-config";
const VOICE_PROMPTS_KEY = "ssc:voice-prompts"; // iter-23: "1" = TTS prompts on (default), "0" = mute

const safeParse = (raw, fallback = null) => {
  try {
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

export const LocalStore = {
  getActiveSession: () => safeParse(localStorage.getItem(ACTIVE_KEY)),
  setActiveSession: (session) => {
    if (!session) localStorage.removeItem(ACTIVE_KEY);
    else localStorage.setItem(ACTIVE_KEY, JSON.stringify(session));
  },
  getDraft: () => safeParse(localStorage.getItem(DRAFT_KEY), {}),
  setDraft: (draft) => localStorage.setItem(DRAFT_KEY, JSON.stringify(draft || {})),
  clearDraft: () => localStorage.removeItem(DRAFT_KEY),

  getSyncConfig: () => safeParse(localStorage.getItem(SYNC_KEY), {}),
  setSyncConfig: (cfg) => localStorage.setItem(SYNC_KEY, JSON.stringify(cfg || {})),

  // iter-23: voice TTS prompts toggle. Default ON (true).
  getVoicePrompts: () => localStorage.getItem(VOICE_PROMPTS_KEY) !== "0",
  setVoicePrompts: (on) => localStorage.setItem(VOICE_PROMPTS_KEY, on ? "1" : "0"),
};

export const padSeq = (n, width = 3) => String(n).padStart(width, "0");

export const buildFilename = (sessionName, baseTags, seq) => {
  const clean = (s) =>
    (s || "")
      .toString()
      .trim()
      .replace(/[^a-zA-Z0-9-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  const name = clean(sessionName) || "session";
  const tags = clean(baseTags) || "untagged";
  return `${name}_${tags}_${padSeq(seq)}.jpg`;
};
